module.exports = __webpack_public_path__ + "static/media/8_sobaka_46.41_1.3.1e2df9e6.png";